exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n.footer_footer_1LQrk {\n    padding: 10px 0;\n    margin-top: 10px;\n    border-top: 2px solid var(--ui-black-transparent);\n}\n\n.footer_footer_1LQrk a {\n    font-weight: bold;\n    text-decoration: none;\n    cursor: pointer;\n    color: var(--motion-primary);\n}\n\n.footer_footer_1LQrk a.footer_footer-reset-data_2WzbA {\n    color: var(--red-primary);\n}\n\n.footer_footer-content_1g75F {\n    max-width: 600px;\n    margin: auto;\n}\n\n.footer_footer-text_1_OXw {\n    text-align: center;\n    margin: 5px 0 10px 0;\n}\n\n.footer_footer-columns_1ma4J {\n    display: flex;\n    justify-content: center;\n    justify-items: center;\n    flex-wrap: wrap;\n}\n\n.footer_footer-section_2z-CC {\n    display: flex;\n    flex-direction: column;\n    width: 200px;\n    margin-bottom: 10px;\n}\n\n.footer_footer-section_2z-CC > * {\n    margin-bottom: 10px;\n}\n\n.footer_separator_4Zo-C {\n    margin: 0 0.5em;\n    border-left: 1px solid var(--ui-black-transparent);\n    height: 1em;\n}", ""]);

// exports
exports.locals = {
	"footer": "footer_footer_1LQrk",
	"footer-reset-data": "footer_footer-reset-data_2WzbA",
	"footerResetData": "footer_footer-reset-data_2WzbA",
	"footer-content": "footer_footer-content_1g75F",
	"footerContent": "footer_footer-content_1g75F",
	"footer-text": "footer_footer-text_1_OXw",
	"footerText": "footer_footer-text_1_OXw",
	"footer-columns": "footer_footer-columns_1ma4J",
	"footerColumns": "footer_footer-columns_1ma4J",
	"footer-section": "footer_footer-section_2z-CC",
	"footerSection": "footer_footer-section_2z-CC",
	"separator": "footer_separator_4Zo-C"
};